module.exports = __webpack_public_path__ + "img/data-user.199ad445.svg";